import React from 'react';

const UnavailableFeatureIcon = () => (
    <svg width="225" height="250" viewBox="0 0 225 250" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
            {/* Cloud Gradient */}
            <radialGradient id="cloudGradient" cx="0.5" cy="0.5" r="0.6">
                <stop offset="0%" stopColor="white" />
                <stop offset="100%" stopColor="#EDE7F6" />
            </radialGradient>

            {/* Sleeping "Z" Color */}
            <linearGradient id="zGradient" x1="0" y1="0" x2="30" y2="30" gradientUnits="userSpaceOnUse">
                <stop offset="0%" stopColor="#9C27B0" />
                <stop offset="100%" stopColor="#7B1FA2" />
            </linearGradient>
        </defs>

        <g transform="translate(0, -100)">

            {/* Sleeping Face */}
            <circle cx="100" cy="178" r="5" fill="#7B1FA2" />
            <circle cx="125" cy="178" r="5" fill="#7B1FA2" />
            <path d="M103 192 Q112.5 202, 122 192" stroke="#7B1FA2" strokeWidth="2.5" strokeLinecap="round" />

            {/* Loading Bar */}
            <rect x="60" y="210" width="105" height="15" rx="8" fill="#D1C4E9" />
            <rect x="60" y="210" width="55" height="15" rx="8" fill="#7B1FA2" />

            {/* Message Text */}
            <text x="112.5" y="270" fontFamily="Arial, sans-serif" fontSize="18" fill="#7B1FA2" textAnchor="middle">
                Feature Unavailable
            </text>
        </g>
    </svg>
);

export default UnavailableFeatureIcon;